export const swissInsuranceReference2026 = {
  year: 2026,
  pillar3aWithPensionFundMax: 7258,
  pillar3aWithoutPensionFundPercent: 20,
  pillar3aWithoutPensionFundMax: 36288,
  lppEntryThreshold: 22680,
  lppCoordinationDeduction: 26460,
  lppMaxSalaryMandatory: 90720,
  lppMinCoordinatedSalary: 3780,
  lppMaxCoordinatedSalary: 64260,
  uvgMaxInsuredSalary: 148200,
  uvgNonOccupationalThresholdHoursWeek: 8,
  lastVerified: '2026-08-15',
  sourceLabel: 'Ufficio federale delle assicurazioni sociali (UFAS)',
  sourceUrl: 'https://www.bsv.admin.ch/it/previdenza-vecchiaia-previdenza-professionale',
};

export const formatSwissFrancs = (value) =>
  `CHF ${new Intl.NumberFormat('it-CH').format(value)}`;
